<!--
 * @Author: fengjiahua fenjiahua@qq.com
 * @Date: 2024-01-26 14:02:44
 * @LastEditors: fengjiahua fenjiahua@qq.com
 * @LastEditTime: 2024-02-19 14:22:00
-->
<script lang='ts' setup>
import { APP_ROUTER, checkLink, imageTransform } from '@qctsw/common'
import type { PastTopic, TopicArticleBase } from '~/server/types'

withDefaults(defineProps<{
  list: PastTopic[] | TopicArticleBase[]
  cols?: number
  toPage: (id: string) => string
}>(), {
  list: () => [],
  cols: 1,
})

function isTopicData(data: PastTopic | TopicArticleBase): data is PastTopic {
  return 'id' in data
}
</script>

<template>
  <n-grid :y-gap="12" :x-gap="12" :cols="cols">
    <n-gi v-for="item, index in list" :key="index">
      <NuxtLink
        class="flex items-center justify-end h-full relative  rounded-md overflow-hidden"
        :to="checkLink(isTopicData(item) ? APP_ROUTER.topicDetail(item.id) : APP_ROUTER.newsDetail(item.articleId), '') "
      >
        <img
          class="h-full w-full object-cover"
          :alt="item.title"
          :src="imageTransform(isTopicData(item) ? item.coverImg : item.coverImgUrl, { width: 975, height: 540, format: 'jpeg' })"
        >
        <h3 class="title">
          {{ item.title }}
        </h3>
      </NuxtLink>
    </n-gi>
  </n-grid>
</template>

<style lang='scss' scoped>
.title {
  --uno: absolute bottom-0 left-0 w-full h-13 pt-3 leading-10  px-4 text-4 truncate;
  --uno: bg-gradient-to-t from-black text-white font-bold;
}
</style>
